import React from 'react';
import { styled } from '@mui/material';

import { Box, Button, Form, Link, MenuItem, Select, Stack, Text, TextInput } from 'shell/components';
import { TermsOfServiceModal } from 'ensightful-koala-ui';

const SignUpPage = ({
    device = 'desktop',
    loading,
    errors,
    country,
    form,
    ToSModalOpen,
    handleChange,
    handleSignUp,
    setToSModalOpen,
    COUNTRY_OPTIONS,
}) => {
    return (
        <SignUpBox device={device}>
            <Stack alignItems={'center'} spacing={1} sx={{ marginBottom: 6 }}>
                <Text variant={'h6'} weight={'medium'}>
                    Create an Account
                </Text>
                <Text variant={'p1'} sx={{ textAlign: 'center' }}>
                    Sign up to access Ensightful’s unique team management platform for higher education.
                </Text>
            </Stack>

            <Select
                label={'Region'}
                labelId={'region-select'}
                renderValue={(selected) => {
                    return COUNTRY_OPTIONS.find(({ key }) => key === selected).value;
                }}
                value={country}
                onChange={(e) => handleChange('country', e.target.value)}
            >
                {COUNTRY_OPTIONS.map(({ key, value }) => (
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                ))}
            </Select>
            <Form onSubmit={() => handleSignUp()}>
                <InputStack>
                    <TextInput
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                        label={'Email'}
                        value={form.email}
                        onChange={(e) => handleChange('email', e.target.value)}
                        placeholder={'Enter email'}
                        required
                    />
                </InputStack>

                <Stack sx={{ margin: (theme) => theme.spacing(6, 0, 3, 0) }}>
                    <Button loading={loading} type={'submit'}>
                        Sign Up
                    </Button>
                </Stack>
                <Stack alignItems={'center'}>
                    <SignUpText variant={'p3'}>
                        Already have an account? <Link to={'/'}>Login</Link>
                    </SignUpText>
                </Stack>
                <TosContainer>
                    <Text variant={'p3'} sx={{ color: '#616161', textAlign: 'center', whiteSpace: 'nowrap' }}>
                        By signing up, you agree to Ensightful’s{' '}
                        <StyledSpan
                            component={'span'}
                            onClick={() => setToSModalOpen({ tos: !ToSModalOpen.tos, privacy: false })}
                        >
                            Terms of Services
                        </StyledSpan>{' '}
                        and{' '}
                        <StyledSpan
                            component={'span'}
                            onClick={() => setToSModalOpen({ tos: false, privacy: !ToSModalOpen.privacy })}
                        >
                            {' '}
                            Privacy Policy.
                        </StyledSpan>
                    </Text>
                    <TermsOfServiceModal
                        closable
                        mainTitle={ToSModalOpen.tos ? 'Terms of Service' : 'Privacy Policy'}
                        visible={ToSModalOpen.tos || ToSModalOpen.privacy}
                        documentUrl={
                            ToSModalOpen.tos ? process.env.REACT_APP_TOS : process.env.REACT_APP_PRIVACY_POLICY
                        }
                        onCancel={() => setToSModalOpen(false)}
                    />
                </TosContainer>
            </Form>
        </SignUpBox>
    );
};

const SignUpBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: theme.spacing(7),
        height: 'fit-content',
        ...(device === 'mobile' && {
            position: 'relative',
            width: '100%',
        }),
        ...(device === 'tablet' && {
            width: 365,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '12px',
        }),
        ...(device === 'desktop' && {
            width: 450,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '12px',
        }),
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
        gap: 6,
    };
});

const SignUpText = styled(Text)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[700],
    };
});

const StyledSpan = styled(Box)(() => {
    return {
        textDecoration: 'underline',
        color: '#6347ff',

        '&:hover': {
            cursor: 'pointer',
        },
    };
});

const TosContainer = styled(Box)(() => {
    return {
        position: 'absolute',
        bottom: '-30px',
        left: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
});

export default SignUpPage;
